export default {
	keys: {
		saleType: 'comissionType',
		propertyType: 'type',
		price: 'priceHuf',
		area: 'area',
		buildingStructure: 'buildingStructure',
		conditionOfProperty: 'conditionOfProperty',
		heating: 'heating',
		rooms: 'numberOfAllRooms',
		bathrooms: 'numberOfBathrooms',
		elevator: 'elevator',
		comfortLevel: 'comfortLevel',
		parkingOption: 'parkingOption',
		balcony: 'rooms.type',
		view: 'view',
		staircaseType: 'staircaseType',
		livingRoomOrientation: 'livingRoomOrientation',
		keyWord: 'description',
		isOwnedByFactoring: 'isOwnedByFactoring',
		innerHeight: 'innerHeight',
		floorsInBuilding: 'floor',
		page: 'page',
		comissionId: 'comissionId',
		webwalk: 'images.websetaUrl'
	},
	values: {
		saleType: {
			forSell: 'toSell',
			forRent: 'toRent'
		},
		propertyType: {
			flat: 'flat|projectEstate',
			house: 'house|projectEstate',
			flatPlusHouse: 'flat|house|projectEstate',
			parcel: 'parcel',
			garage: 'garage',
			projectEstate: 'projectEstate',
			office: 'office',
			shop: 'shop',
			tourism: 'tourism',
			industrial: 'industrial',
			agricultural: 'agricultural',
			parcelForInnovation: 'parcelForInnovation',
			publicInstitution: 'publicInstitution'
		},
		buildingStructure: {
			wood: ['wood', 'woodHouse'],
			brick: ['brick'],
			shutter: ['shutter'],
			panel: ['panel'],
			lightStructure: ['lightStructure'],
			otherBuildingMaterial: ['adobe', 'silicate', 'rockAndBrick', 'proconcept', 'mixedMasonry', 'passiveHouse', 'otherBuildingMaterial']
		},
		heating: {
			gas: ['gasCirco', 'gasConvector', 'gasHera', 'gasAndAlternative'],
			electric: ['electric'],
			remoteHeating: ['remoteHeating', 'remoteHeatingWithOwnMeasurer'],
			houseCentralized: ['houseCentralized', 'houseCentralizedWithUniqueMeter'],
			otherHeating: ['geotermic', 'furnace', 'stove', 'fanCoil', 'otherHeating'],
			nothing: ['nothing']
		},
		innerHeight: {
			heightLow: '0~2.5',
			heightNormal: '2.6~2.7',
			heightExtra: '2.8~3.5',
			heightLoft: '3.6~'
		},
		conditionOfProperty: {
			uninhabitable: 'uninhabitable',
			toRenew: 'toRenew',
			average: 'average',
			good: 'good',
			excellent: 'excellent',
			newlyBuilt: 'newlyBuilt'
		},
		floorsInBuilding: [
			'underground4',
			'underground3',
			'underground2',
			'underground1',
			'basement',
			'suteren',
			'halfSuteren',
			'downstairs',
			'highDownstairs',
			'halfUpstairs',
			'1',
			'2',
			'3',
			'4',
			'5',
			'6',
			'7',
			'8',
			'9',
			'10',
			'10+'
		],
		webwalk: true,
		isOwnedByFactoring: true,
		elevator: 'key|caller|service',
		balcony: 'terrace|roofTerrace|balcony|loggia|frenchBalcony',
		comfortLevel: {
			doubleComfort: ['doubleComfort'],
			fullComfort: ['fullComfort'],
			other: ['comfort', 'withoutComfort', 'halfComfort', 'luxurious']
		},
		miscellaneous: {
			pool: 'medence',
			withGardenAccess: 'kertkapcsolat',
			topFloor: 'tetoteri'
		},
		parkingOption: {
			roomGarage: 'roomGarage',
			closedPlace: 'closedPlace',
			openedPlace: 'openedPlace',
			publicPayment: 'publicPayment',
			publicFree: 'publicFree'
		},
		'rooms.type': {
			balcony: 'erkely',
			terrace: 'terasz-tetoterasz',
			roofTerrace: 'terasz-tetoterasz',
			loggia: 'loggia',
			frenchBalcony: 'francia-erkely'
		},
		view: {
			street: 'street',
			yard: 'yard',
			garden: 'garden',
			panorama: 'panorama'
		},
		staircaseType: {
			closed: 'closed',
			circularCorridor: 'circularCorridor',
			other: 'other'
		},
		livingRoomOrientation: {
			north: ['North', 'NorthEast', 'NorthWest'],
			east: ['East', 'NorthEast', 'SouthEast'],
			south: ['South', 'SouthEast', 'SouthWest'],
			west: ['West', 'NorthWest', 'SouthWest']
		}
	}
};
